<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="600" height="600" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Hồ sơ chi tiết
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row v-if="staff.id">
          <v-col class="d-flex align-center pt-4 pb-0" cols="12">
            <v-subheader class="py-0 px-0">Họ và tên</v-subheader>
            <p class="mb-0">{{ staff.name }}</p>
          </v-col>
          <v-col class="py-0 align-center d-flex" cols="12">
            <v-subheader class="px-0">Tài khoản</v-subheader>
            <p class="mb-0">{{ staff.code }}</p>
          </v-col>
          <v-col class="py-0 align-center d-flex" cols="12">
            <v-subheader class="px-0">Vai trò</v-subheader>
            <p class="mb-0">{{ staff.role.description }}</p>
          </v-col>
          <v-col class="py-0 align-center d-flex" cols="12">
            <v-subheader class="px-0">Email</v-subheader>
            <p class="mb-0">{{ staff.email }}</p>
          </v-col>
          <v-col class="py-0 align-center d-flex" cols="12">
            <v-subheader class="px-0">Số điện thoại</v-subheader>
            <p class="mb-0">{{ staff.phone }}</p>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions v-if="$auth.policies['update-staff']">
        <v-spacer></v-spacer>
        <v-btn @click="editState" class="ma-2" outlined color="#0D47A1">Sửa hồ sơ người dùng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    state: Boolean,
    staff: Object
  },
  data: () => ({
    dialog: false
  }),
  methods: {
    cancel() {
      this.dialog = false
    },
    editState() {
      this.$emit('edit')
      this.dialog = false
    }
  },
  watch: {
    state() {
      this.dialog = true
    }
  }
}
</script>

<style scoped>
.v-subheader {
  width: 30%;
}
p {
  color: black;
}
.p > .v-input__control > .v-input__slot:before {
  border-style: none;
}
</style>
